import { useEffect, useState, useCallback } from "react";
import { isJSON } from "../../util/isJSON"

/**
 * Hook personalizado que maneja los datos de usuario y contraseña del login.
 * obtiene los datos del localstorage.
 * actualiza las credenciales en el localstorage.
 * remueve las credenciales del localstorage.
 * 
 * 
 * @returns {{active: bool,  user: string, password: string,  setCredentials: function setCredentials(user, password), removeCredentials: function removeCredentials()}} -Objeto con los siguientes datos:
 * active: booleano que indica si los datos existen en el localstorage
 * user: string del nombre del usuario guardado
 * password: string con la contraseña guardada
 * setCredentials: metodo que actualiza las credenciales en el localstorage
 * removeCredentials: metodo que elimina las credenciales en el localstorage
 */
export const useRememberPassword = () => {
    const [check, setCheck] = useState(false);
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const localStorageKey = "credentials";

    const getCredentials = useCallback(() => {
        const validStorage = localStorage.getItem(localStorageKey) && isJSON(localStorage.getItem(localStorageKey));
        
        if (validStorage) {
            const _user = JSON.parse(window.localStorage.getItem(localStorageKey))?.user;
            const _password = JSON.parse(window.localStorage.getItem(localStorageKey))?.password;
            setCheck(true)
            setUser(_user);
            setPassword(_password);
        } else {
            setCheck(false)
        }
    });

    useEffect(() => {
        getCredentials();
    }, [check])

    const setCredentials = ({ user, password }) => {
        window.localStorage.setItem(localStorageKey, JSON.stringify({
            user: user,
            password: password
        }));
    };

    const removeCredentials = () => {
        window.localStorage.removeItem(localStorageKey);
    };

    return {
        active: check,
        user: user,
        password: password,
        setCredentials,
        removeCredentials
    }
}